(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Service, Model) {
    'use strict';

    Controller.flowA = function (modo, combo) {
        Service.getFlow('A', { modo: modo || Model.Window.modo, combo: combo || Model.Window.combo });
    }

    Controller.flowB = function (combo, options) {
        Service.getFlow('B', combo, options);
    }

    Controller.flowC = function () {
        Service.getFlow('C');
    }

    Controller.flowD = function (data) {
        Service.getFlow('D', Model.Cliente);
    }

    Controller.flowE = function () {
        Service.getFlow('E');
    }

    Controller.flowF = function () {
        Service.getFlow('F');
    }

    Controller.flowG = function () {
        Service.getFlow('G');
    }

})(LN.Controller, LN.Service, LN.Model);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/flowController.js